var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSharpStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3876 16.6279L12 16.394L11.6124 16.6279L6.9542 19.4394L8.19039 14.1404L8.29323 13.6995L7.95108 13.4031L3.83463 9.83704L9.2534 9.37732L9.70405 9.33908L9.88054 8.92267L12 3.92195L14.1195 8.92267L14.2959 9.33908L14.7466 9.37732L20.1654 9.83704L16.0489 13.4031L15.7068 13.6995L15.8096 14.1404L17.0458 19.4394L12.3876 16.6279Z",
    stroke: "#239EC2",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharpStar);
export default __webpack_public_path__ + "static/media/ic_sharp-star.ebd80d20fbc828d4142d0ae11f50c5f1.svg";
export { ForwardRef as ReactComponent };